import { cn } from "@ui/lib/utils";
import clsx from "clsx";
import * as m from "motion/react-m";

/**
 * Wrapper component for demo components with styling and animation.
 *
 * ⚠️ If you use this wrapper directly inside your demo component, you MUST exclude it
 * in BlockDemos.tsx and BlockDemosV2.tsx to prevent double-wrapping.
 */
export function OmniboxComponentWrapper({
  children,
  component,
  size,
  initiallyVisible,
  className,
  withBorder = true,
  shadow = "lg",
}: {
  children: React.ReactNode;
  className?: string;
  component: string;
  initiallyVisible: boolean;
  size: string;
  withBorder?: boolean;
  shadow?: "lg" | "combined" | "none";
}) {
  return (
    <div
      className={clsx(
        "omnibox-wrapper overflow-y-auto rounded-xl bg-default",
        withBorder && "border",
        shadow === "lg" && "shadow-lg",
        shadow === "combined" && "shadow-combined",
      )}
    >
      <m.div
        animate={{ opacity: 1 }}
        className={cn(
          "h-[340px] outline-none md:h-[375px]",
          {
            "md:h-[500px]": size === "xl",
            "lg:h-[550px]": size === "2xl",
            "h-[500px]": component === "videoToMusic",
          },
          className,
        )}
        initial={{ opacity: initiallyVisible ? 1 : 0 }}
        transition={{ duration: 0.5 }}
      >
        {children}
      </m.div>
    </div>
  );
}
